const PHONE_WIDTH = 768;

type Platform = 'webMobile' | 'webOther';
type Translate = (key: string, options?: Record<string, unknown>) => string;

export class DisplayUtil {
  static getDisplayWidth = (): number => window.outerWidth || window.screen.width;

  static getPlatform = (): Platform => (this.isPhone() ? 'webMobile' : 'webOther');

  static isPhone = (): boolean => DisplayUtil.getDisplayWidth() < PHONE_WIDTH;

  static getDistanceText = (t: Translate, distance?: string | number): string => {
    if (distance == null || distance === '') return '';
    const miles = Number(distance);
    if (Number.isNaN(miles)) return `${distance}`;
    if (miles <= 1) return t('common.distanceUnder1');
    return t('common.distanceMiles', { distance: miles });
  };
}
